
<template>
  <v-dialog
    v-model="show"
    :color="options.color"
    :title="title"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex, position: 'absolute' }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text
        v-show="!!message"
        v-html='message'
        class="pa-4 text-body-1" />
      <v-card-actions class="pt-0">
        <v-spacer/>
        <v-btn
          id="yes_btn"
          color="red"
          @click.native="agree">Yes</v-btn>
        <v-btn
          id="no_btn"
          color="danger"
          @click.native="cancel">{{options.cancelLabel}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 *
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      cancelLabel: 'Cancel',
      color: 'danger',
      width: 350,
      zIndex: 500
    }
  }),
  computed: {
    show: {
      get () {
        return this.dialog
      },
      set (value) {
        this.dialog = value
        if (value === false) {
          this.cancel()
        }
      }
    }
  },
  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
